if (!customElements.get('mm-carousel')) {
  customElements.define(
    'mm-carousel',
    class MMCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-mm-track]');
        if (!this.track) return;
        this.slides = Array.from(this.track.children);
        this.dots = Array.from(this.querySelectorAll('[data-mm-dot]'));
        this.status = this.querySelector('[data-mm-status]');

        this.querySelectorAll('[data-mm-prev]').forEach((btn) =>
          btn.addEventListener('click', () => this.step(-1))
        );
        this.querySelectorAll('[data-mm-next]').forEach((btn) =>
          btn.addEventListener('click', () => this.step(1))
        );

        this.track.addEventListener('scroll', () => {
          clearTimeout(this.scrollTimer);
          this.scrollTimer = setTimeout(() => this.sync(), 80);
        });
        this.sync();
      }

      current() {
        const left = this.track.scrollLeft;
        let index = 0;
        let best = Infinity;
        this.slides.forEach((slide, i) => {
          const d = Math.abs(slide.offsetLeft - left);
          if (d < best) {
            best = d;
            index = i;
          }
        });
        return index;
      }

      step(direction) {
        const index = Math.min(Math.max(this.current() + direction, 0), this.slides.length - 1);
        const slide = this.slides[index];
        if (slide) this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
      }

      sync() {
        const index = this.current();
        this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
        if (this.status && this.dataset.statusTemplate) {
          this.status.textContent = this.dataset.statusTemplate
            .replace('[n]', index + 1)
            .replace('[total]', this.slides.length);
        }
      }
    }
  );
}
